import React from "react";
import { MaskLines } from "./Motion";

export const PageHeader = ({ overline, title, subtitle, dark = false }) => (
  <section
    data-testid="page-header"
    className={`pt-36 sm:pt-44 pb-16 sm:pb-20 ${dark ? "bg-[#121212] text-[#F5F2EA] grain relative" : ""}`}
  >
    <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
      <p className={`overline mb-6 ${dark ? "text-[#D9BE86]" : "text-[#C6A15B]"}`}>{overline}</p>
      <MaskLines
        lineClass="font-serif font-light text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-[0.95]"
        lines={Array.isArray(title) ? title : [title]}
        delay={0.1}
      />
      {subtitle && (
        <p className={`mt-8 max-w-2xl text-lg leading-relaxed ${dark ? "text-white/60" : "text-[#7a7568]"}`}>
          {subtitle}
        </p>
      )}
    </div>
  </section>
);
